import React, { useEffect, Children, isValidElement } from 'react'

// Next.js <Head> shim: sets document.title from the first <title> child.
//
// setTimeout(0) defers past all synchronous useEffect hooks in the tree,
// including the generic title setter in _authenticated.tsx which would
// otherwise overwrite a page-specific title (React runs parent effects after
// child effects, so the parent wins in a same-tick race).
// The cleanup cancels the timeout if the component unmounts first (Strict Mode).
export default function Head({ children }: { children?: React.ReactNode }) {
    useEffect(() => {
        const id = setTimeout(() => {
            Children.forEach(children, child => {
                if (isValidElement(child) && child.type === 'title') {
                    const c = (child.props as any).children
                    document.title = Array.isArray(c) ? c.join('') : String(c ?? '')
                }
            })
        }, 0)
        return () => clearTimeout(id)
    })
    return null
}
